import { call, put, takeLatest } from "redux-saga/effects";
import {
  miniGamesInitRequest,
  miniGamesInitSuccess,
  miniGamesInitFailure,
} from "./miniGamesActions";
import { getMiniGames } from "../../services/api";
import { AxiosResponse } from "axios";

function* initMiniGamesWorker() {
  try {
    const res: AxiosResponse = yield call(getMiniGames);

    const games = res?.data;

    if (games) {
      yield put(miniGamesInitSuccess({ games }));
    } else {
      yield put(miniGamesInitFailure("Mini games data not found"));
    }
  } catch (e: any) {
    console.log("[saga] mini games error:", e);
    const msg =
      e?.message || e?.response?.data?.error || "Failed to load mini games";
    yield put(miniGamesInitFailure(msg));
  }
}

export function* miniGamesRootSaga() {
  yield takeLatest(miniGamesInitRequest.type, initMiniGamesWorker);
}
